<div *ngIf="product" class="d-flex align-items-center" style="margin-left: .75rem; margin-right: .75rem; margin-top: 2.5em; margin-bottom: 5em">
  <div class="d-flex flex-column" style="max-width: 195px; width: 100%;margin-bottom:10px">
    <p style="font-family: 'Poppins', serif;font-size: 16px; font-weight: 600;line-height: 1;margin-bottom: 2px">Vehículo</p>
    <p class="mb-0" style="font-family: 'Poppins', serif;font-size: 20px;font-weight: 400;line-height: 1;">{{product?.vehicle?.name}}</p>
  </div>

                  <div class="d-flex flex-row flex-wrap" style="gap: 1.25em;padding-left: 2em;width: 65%;margin-top: 2.3em;">

                    <div class="d-flex flex-column" style="gap: 1.8em;">
                      <div class="d-flex align-items-center justify-content-end" style="gap: .35em;">
                        <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color:black;">{{ product?.vehicle.maxPax }}</p>
                        <img src="../../../../../assets/icons/search-result/persona.svg" width="30px" height="30px" alt="">
                        <div class="d-flex flex-column">
                          <p class="rubik-regular-12pt mb-0 " style="font-weight: 400; color:black;border-left: .5px solid #b9b9b9;padding-left: .6em">Personas</p>
                          <p class="rubik-regular-12pt mb-0 " style="font-weight: 400; color:black;border-left: .5px solid #b9b9b9;padding-left: .6em">por
                            vehículo</p>
                        </div>
                      </div>


                      <div class="d-flex align-items-center justify-content-end" style="gap: .35em;">
                        <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color:black;">{{ product?.vehicle?.bag?.maxBag }}</p>
                        <img src="../../../../../assets/icons/search-result/maleta.svg" width="30px" height="30px" alt="">
                        <div class="d-flex flex-column">
                          <p class="rubik-regular-12pt mb-0" style="font-weight: 400; color:black;border-left: .5px solid #b9b9b9;padding-left: .6em">Valijas
                          </p>
                          <p class="rubik-regular-12pt mb-0" style="font-weight: 400; color:black;border-left: .5px solid #b9b9b9;padding-left: .6em">por
                            vehículo</p>
                        </div>
                      </div>
                      </div>


                      <div class="d-flex flex-column" style="gap: 1em;margin-left: 45px;">

                         <div class="d-flex align-items-center justify-content-center"
                        style="gap: .25em; background-color: #f0f0f0; border-radius: 5px; padding: 5px; border: .5px solid #dadada; width: 120px;">
                        <img src="../../../../../assets/icons/search-result/tiempo.svg" width="30px" height="30px" alt="">
                        <div class="d-flex flex-column">
                          <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 400; color:black;border-left: .5px solid #b9b9b9;">
                            {{roundTripTime}}
                          </p>
                          <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 400; color:black;border-left: .5px solid #b9b9b9;">Minutos
                          </p>
                        </div>
                      </div>


                        <div class="info-tool d-flex flex-column position-relative" *ngIf="product.timing.return.returnTravelTime">
                        <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                        <span class="tooltip-info shadow-md">
                          <table class="table-info-tool">
                            <tr style="border-bottom: 1px solid #ececec;">
                              <th style="text-align: center">
                                <div class="d-flex align-items-center justify-content-center" style="min-height: 45px;">
                                  <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 500; color:black;">Minutos</p>
                                </div>
                              </th>
                            </tr>
                            <tr>
                              <td class="d-flex flex-column justify-content-center align-items-center" style="height: 38px;">
                                <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 500; color:black;">
                                  Ida:
                                  {{product.timing.entry.entryTravelTime}}
                                  Minutos
                                </p>

                                <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 500; color:black;">
                                  Vuelta:
                                  {{product.timing.return.returnTravelTime}}
                                  Minutos
                                </p>
                              </td>
                            </tr>
                          </table>
                        </span>
                      </div>


                      <div class="d-flex align-items-center" style="gap: .25em;">
                        <!-- result['vehicles'].length -->
                        <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color:black;">{{ product?.vehicle?.bag.numberHandbags ?
                          product?.vehicle.bag.numberHandbags : 0 }}</p>
                        <img src="../../../../../assets/icons/search-result/carry.svg" width="30px" height="30px" alt="">
                        <div class="d-flex flex-column">
                          <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 400; color:black;border-left: .5px solid #b9b9b9;">Valijas de
                            mano
                          </p>
                          <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 400; color:black;border-left: .5px solid #b9b9b9;">por
                            vehiculo</p>
                        </div>
                      </div>


                      </div>

                          <div class="d-flex flex-column justify-content-center align-items-center py-1" style="gap: .5em; border: 2px solid #bfbfbf; border-radius: 8px; width: 160px; height: 75px; margin-left: 35px;">
                        <div class="d-flex align-items-center" style="gap: .5em">
                            <img src="../../../../../assets/icons/search-result/caja automática 02.svg" width="22px" height="22px" alt="" />
                            <p class="rubik-regular-12pt mb-0" style="font-weight: 400; color:black;">{{product?.vehicle?.transmision === 'Automático' ? 'automática' : 'manual'}}</p>
                        </div>
                        <div class="d-flex align-items-center" style="gap: .5em">
                           <img src="../../../../../assets/icons/search-result/aire acondicionado 02.svg" width="22px" height="22px" alt="" />
                      <p class="rubik-regular-12pt mb-0" style="font-weight: 400; color:black;">{{product?.vehicle?.transmision === 'Con Aire Acondicionado' ? 'aire' : 'sin aire'}}</p>
                        </div>
                      </div>



                    </div>




    <div class="d-flex justify-content-center" style="margin-top: 2.4em;padding-right: 2.4em;">
      <img src="{{product.images[0]?.thumbnail}}" width="auto" height="auto" alt="" style="background-size: cover; width: 150px;">
    </div>
</div>

<div class="d-flex mb-2 mt-3" style="border: 1px solid #ccc; border-radius: 6px;margin-left: .75em;margin-right: .75em">
  <div class="d-flex align-items-center " style="width: 47.5%;gap: .5em;padding-top: 12px; padding-bottom: 12px">
    <img class=" ml-3" src="../../../../../../assets/icons/search-result/tour/gps.svg" width="22px"
      height="22px" alt="">
    <p class="mb-0 vehicle-top-text pr-3" style="font-size: 15px !important; line-height: 1;">
      {{extractNameTransport(infoTransfer.firstOrigin, 'origin')}} >
      {{extractNameTransport(infoTransfer.firstDestination, 'destination')}}
    </p>
  </div>
  <div class="d-flex align-items-center"
    style="width: 23.5%; border-left: 1px solid #ccc;border-right: 1px solid #ccc; gap: .5em;padding-top: 12px; padding-bottom: 12px; padding-left: 1.2em">
    <img src="../../../../../../assets/icons/itinerary/calendar_13937514.svg" width="30px" height="30px" alt="">
    <p class="mb-0 vehicle-top-text" style="font-size: 15px !important;">
      {{resolvedFirstArrivalDate | date : 'EEEE dd MMMM' : undefined : 'es'}}
    </p>
  </div>
  <div class="d-flex align-items-center" style="width: 23.5%; gap: .5em;padding-top: 12px; padding-bottom: 12px; padding-left: 2em">
    <img src="../../../../../../assets/icons/itinerary/persona.svg" width="22px" height="22px" alt="">
    <p class="mb-0 vehicle-top-text" style="font-size: 15px !important;">
      {{infoTransfer.firstqtyAdults}} {{infoTransfer.firstqtyAdults === 1 ? 'adulto' : 'adultos'}} -
      {{infoTransfer.firstqtyChilds}} {{infoTransfer.firstqtyChilds > 1 ? 'niños' : 'niño'}}
    </p>
  </div>
</div>

<div class="d-flex flex-column " style="background-color: #f9f9f9; margin-left: .75em; margin-right: .75em;margin-top: 25px;margin-bottom:25px; padding-top: 2.2em; padding-bottom:2.2em;">
  <div class="d-flex mx-auto" style="width: 97%">
    <div class="d-flex flex-column " style="width: 25%;">
      <div class="d-flex flex-column" style="margin-bottom: 40px;margin-left: 17px;">
        <p  style="font-family: 'Poppins', serif;font-size: 17px; font-weight: 600;line-height: 1;margin-bottom: 4px">Inicio: </p>
        <p  style="font-family: 'Poppins', serif;font-size: 17px; font-weight: 600;line-height: 1;margin-bottom: 3px">{{resolvedFirstArrivalDate | date : 'dd MMM yyyy'}}</p>
        <p class="mb-0" style="font-family: 'Poppins', serif;font-size: 15px; font-weight: 400;line-height: 1;">{{infoTransfer.firstTime }} hs.</p>
      </div>
      <div class="d-flex flex-column" style="margin-left: 17px;">
        <p  style="font-family: 'Poppins', serif;font-size: 17px; font-weight: 600;line-height: 1;margin-bottom: 4px">Fin: </p>
        <p  style="font-family: 'Poppins', serif;font-size: 17px; font-weight: 600;line-height: 1;margin-bottom: 3px">{{(resolvedSecondArrivalDate ? resolvedSecondArrivalDate : resolvedFirstArrivalDate) | date : 'dd MMM yyyy'}}</p>
        <p class="mb-0" style="font-family: 'Poppins', serif;font-size: 15px; font-weight: 400;line-height: 1;">{{getTimeDropoff()}} hs.</p>
      </div>
    </div>
    <div class="d-flex flex-column" style="width: 25%;">
      <div *ngIf="quote" class="d-flex flex-column ml-1" style="margin-bottom: 40px">
        <p  style="font-family: 'Poppins', serif;font-size: 17px; font-weight: 600;line-height: 1;margin-bottom: 4px">Precio viaje </p>
       <div class="d-flex" style="margin-bottom: 3px">
         <p class="mb-0"  style="font-family: 'Poppins', serif;font-size: 17px; font-weight: 400;line-height: 1;">{{currencyAgency?.code}} {{ product?.totalPriceProf
                | currencyConverterPure:
                product?.pricing?.currency:
                currencyAgency.code:
                currencies
                | number: '1.2-2'}}</p>
         <usb-tooltip-convert-amount [clientsSettingAppBooking]="clientSetting"
                    [currencyProduct]="product.pricing?.currency"
                    [valueProduct]="product.totalPriceProf"></usb-tooltip-convert-amount>
       </div>

        <p class="mb-0" style="font-family: 'Poppins', serif;font-size: 13px; font-weight: 400;line-height: 1;">imp. incluidos</p>
      </div>
      <div *ngIf="quote" class="d-flex flex-column ml-1">
        <p  style="font-family: 'Poppins', serif;font-size: 17px; font-weight: 600;line-height: 1;margin-bottom: 4px">Adicionales </p>
        <div class="d-flex" style="margin-bottom: 3px">
           <p class="mb-0"  style="font-family: 'Poppins', serif;font-size: 17px; font-weight: 400;line-height: 1;">{{currencyAgency?.code}} {{ (product.amenitiesIncluded?.length > 0 ? product?.netPriceBookingWithIncluded - product?.totalPriceProf : 0)
                | currencyConverterPure:
                product?.pricing?.currency:
                currencyAgency.code:
                currencies
                | number: '1.2-2'}}</p>
                <usb-tooltip-convert-amount [clientsSettingAppBooking]="clientSetting"
                    [currencyProduct]="product.pricing?.currency"
                    [valueProduct]="(product?.netPriceBookingWithIncluded - product?.totalPriceProf)"></usb-tooltip-convert-amount>
        </div>

        <p  style="font-family: 'Poppins', serif;font-size: 13px; font-weight: 400;line-height: 1;">imp. incluidos</p>
      </div>

    </div>
     <div class="d-flex flex-column" style="gap: 1em;width: 25%;">
        <div class="d-flex" style="gap: .25em;margin-bottom: 38px;">
          <img src="../../../../../assets/icons/itinerary/reloj-circular.svg" width="25px" height="25px" alt="">
          <div class="d-flex flex-column">
            <p style="font-family: 'Poppins', serif;font-size: 17px; font-weight: 600;line-height: 1;margin-bottom: 4px">Duración:</p>
            <p style="font-family: 'Poppins', serif;font-size: 17px; font-weight: 400;line-height: 1;margin-bottom: 3px">{{product?.timing?.entry?.entryTravelTime}} minutos</p>
          </div>
        </div>
        <div class="d-flex flex-column">
          <div>
            <p style="font-family: 'Poppins', serif;font-size: 17px; font-weight: 400;line-height: 1;margin-bottom: 3px">
              Condiciones
            </p>
          </div>
          <div class="d-flex flex-column">
            <div class="d-flex flex-column">
              <span *ngIf="product?.pricing?.rateClass === 'R'">
                <div class="d-flex align-items-center">
                   <i class="bi bi-check-lg" style="line-height: 1"></i>
                  <p style="font-family: 'Poppins', serif;font-size: 15px; font-weight: 600;line-height: 1;margin-bottom: 2px; color: #69d299">REEMBOLSABLE</p>
                </div>
                <p class="mb-0"  (click)="openPolitics()"
                  style="font-family: 'Poppins', serif;font-size: 15px; font-weight: 600;line-height: 1;cursor: pointer; text-decoration: underline;color: #69d299;">Ver políticas</p>
              </span>
              <span *ngIf="product?.pricing?.rateClass === 'NR'">
                <div class="d-flex ">
                  <p style="font-family: 'Poppins', serif;font-size: 15px; font-weight: 600;line-height: 1;margin-bottom: 2px; color: #B70D35;">No Reembolsable</p>
                </div>
                <p class="mb-0" style="font-family: 'Poppins', serif;font-size: 15px; font-weight: 600;line-height: 1; color: #B70D35;">100% Tarifa</p>
              </span>
            </div>
          </div>
        </div>
      </div>
    <div class="d-flex flex-column " style="width: 22%;">
        <div style="margin-bottom: 44px;">
          <p style="font-family: 'Poppins', serif;font-size: 17px; font-weight: 400;line-height: 1;margin-bottom: 4px">Tipo de traslado</p>
          <p style="font-family: 'Poppins', serif;font-size: 23px; font-weight: 600;line-height: 1;margin-bottom: 4px">{{product?.transferType}}</p>
        </div>
        <div style="width: 155.7px">
          <img src="{{product?.logo}}" style="height: 55px;width: 100%;object-fit: contain;" alt="">
        </div>
      </div>
  </div>
</div>

<div *ngIf="amenitiesVisible()" class="d-flex mb-2 mt-2  pt-2 pb-4" style="border: 1px solid #ccc; border-radius: 6px; margin-left: .75em; margin-right: .75em;">
  <div class="d-flex flex-column w-100 ml-4">
    <p class="mb-0 vehicle-middle-title">Incluido</p>
    <div class="d-flex flex-column">
      <ng-container *ngIf="hasIncludedAmenities(); else noIncluded">
        <ng-container *ngFor="let includes of product.amenities">
          <ng-container *ngIf="includes?.included">
            <div class="d-flex align-items-center">
              <i class="bi bi-check" style="line-height: 1;color: #00d096;font-size: 1.5em;"></i>
              <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 12px;">
                {{includes.name}}
              </p>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-template #noIncluded>
        <p class="mb-0 text-muted" style="font-family: 'Rubik', serif; font-size: 12px;">N/A</p>
      </ng-template>
    </div>
  </div>
  <div class="d-flex flex-column w-100">
    <p class="mb-0 vehicle-middle-title">Adicionales</p>
    <div class="d-flex flex-column">
      <ng-container *ngIf="product.amenitiesIncluded && product.amenitiesIncluded.length > 0">
        <ng-container *ngFor="let includes of product.amenitiesIncluded">
          <div class="d-flex">
            <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 12px;">
              {{includes.name}} <span style="font-weight: 600;">
                <!-- ({{currencySelected}} {{includes.price | number: '1.2-2'}}) -->
                ({{currencyAgency?.code}} {{ includes.price
                | currencyConverterPure:
                currencySelected:
                currencyAgency.code:
                currencies
                | number: '1.2-2'}})
              </span>
            </p>
            <usb-tooltip-convert-amount [clientsSettingAppBooking]="clientSetting"
                      [currencyProduct]="includes.currency"
                      [valueProduct]="includes.totalPriceProf">
            </usb-tooltip-convert-amount>
          </div>
        </ng-container>
      </ng-container>
       <ng-container *ngIf="product.amenitiesIncluded && product.amenitiesIncluded.length === 0">
         <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 12px;">N/A</p>
       </ng-container>
    </div>
  </div>
</div>

<!-- Traslado de Llegada (solo si destino es aeropuerto) -->
<div *ngIf="getArrivalFlight() as flight" class="d-flex mb-2 mt-2 pt-3 pb-5"
  style="border: 1px solid #ccc; border-radius: 6px; margin-right: .75em; margin-left: .75em;">
  <div class="d-flex flex-column w-100 mx-4">

    <div>
      <p class="mb-0 text-description-accordion">Traslado de Llegada: <span style="font-weight: 600">
        {{extractNameTransport(infoTransfer.firstOrigin, 'origin')}} → {{extractNameTransport(infoTransfer.firstDestination, 'destination')}}
      </span></p>
    </div>

    <!-- Fila 1: Aerolínea y Nro. Vuelo -->
    <div class="d-flex mt-4" style="gap: 1em;">
      <div class="d-flex flex-column" style="flex: 2;">
        <label class="ml-3" style="font-family: 'Rubik', serif; font-size: 13px; font-weight: 600;">Aerolínea</label>
        <input type="text" class="py-2 pl-3"
          style="font-family: 'Rubik', serif; font-size: 13px; border: 1px solid #ccc; border-radius: 6px;"
          [value]="flight.airlineIn || 'No especificada'" readonly>
      </div>
      <div class="d-flex flex-column" style="flex: 1;">
        <label class="ml-3" style="font-family: 'Rubik', serif; font-size: 13px; font-weight: 600;">Nro. Vuelo</label>
        <input type="text" class="py-2 pl-3"
          style="font-family: 'Rubik', serif; font-size: 13px; border: 1px solid #ccc; border-radius: 6px;"
          [value]="flight.flyNumberIn" readonly>
      </div>
    </div>

    <!-- Fila 2: Aeropuerto de Llegada y Hora -->
    <div class="d-flex mt-3" style="gap: 1em;">
      <div class="d-flex flex-column" style="flex: 2;">
        <label class="ml-3" style="font-family: 'Rubik', serif; font-size: 13px; font-weight: 600;">Aeropuerto de Llegada</label>
        <input type="text" class="py-2 pl-3"
          style="font-family: 'Rubik', serif; font-size: 13px; border: 1px solid #ccc; border-radius: 6px;"
          [value]="flight.airportIn || extractNameTransport(infoTransfer.firstDestination, 'destination')" readonly>
      </div>
      <div class="d-flex flex-column" style="flex: 1;">
        <label class="ml-3" style="font-family: 'Rubik', serif; font-size: 13px; font-weight: 600;">Hora de Llegada</label>
        <input type="text" class="py-2 pl-3"
          style="font-family: 'Rubik', serif; font-size: 13px; border: 1px solid #ccc; border-radius: 6px;"
          [value]="_extractHourMinute(flight.arrivalIn)" readonly>
      </div>
    </div>

  </div>
</div>

<div *ngIf="getDepartureFlight() as flight" class="d-flex mb-2 mt-2 pt-3 pb-5"
  style="border: 1px solid #ccc; border-radius: 6px; margin-right: .75em; margin-left: .75em;">
  <div class="d-flex flex-column w-100 mx-4">

    <div>
      <p class="mb-0 text-description-accordion">Traslado de Salida: <span style="font-weight: 600">
        {{extractNameTransport(infoTransfer.firstOrigin, 'origin')}} → {{extractNameTransport(infoTransfer.firstDestination, 'destination')}}
      </span></p>
    </div>

    <!-- Fila 1: Aerolínea y Nro. Vuelo -->
    <div class="d-flex mt-4" style="gap: 1em;">
      <div class="d-flex flex-column" style="flex: 2;">
        <label class="ml-3" style="font-family: 'Rubik', serif; font-size: 13px; font-weight: 600;">Aerolínea</label>
        <input type="text" class="py-2 pl-3"
          style="font-family: 'Rubik', serif; font-size: 13px; border: 1px solid #ccc; border-radius: 6px;"
          [value]="flight.airlineOut || 'No especificada'" readonly>
      </div>
      <div class="d-flex flex-column" style="flex: 1;">
        <label class="ml-3" style="font-family: 'Rubik', serif; font-size: 13px; font-weight: 600;">Nro. Vuelo</label>
        <input type="text" class="py-2 pl-3"
          style="font-family: 'Rubik', serif; font-size: 13px; border: 1px solid #ccc; border-radius: 6px;"
          [value]="flight.flyNumberOut" readonly>
      </div>
    </div>

    <!-- Fila 2: Aeropuerto de Salida y Hora -->
    <div class="d-flex mt-3" style="gap: 1em;">
      <div class="d-flex flex-column" style="flex: 2;">
        <label class="ml-3" style="font-family: 'Rubik', serif; font-size: 13px; font-weight: 600;">Aeropuerto de Salida</label>
        <input type="text" class="py-2 pl-3"
          style="font-family: 'Rubik', serif; font-size: 13px; border: 1px solid #ccc; border-radius: 6px;"
          [value]="flight.airportOut || extractNameTransport(infoTransfer.firstOrigin, 'origin')" readonly>
      </div>
      <div class="d-flex flex-column" style="flex: 1;">
        <label class="ml-3" style="font-family: 'Rubik', serif; font-size: 13px; font-weight: 600;">Hora de Salida</label>
        <input type="text" class="py-2 pl-3"
          style="font-family: 'Rubik', serif; font-size: 13px; border: 1px solid #ccc; border-radius: 6px;"
          [value]="_extractHourMinute(flight.departureOut)" readonly>
      </div>
    </div>

  </div>
</div>

  <usb-accordion-info-product
    #accordionComponent
    [items]="accordionItems"
    [config]="accordionConfig"
    [categoryId]="8"
    (itemToggle)="onAccordionToggle($event)"
    style="margin-right: .75em;margin-left: .75em;">

    <ng-template #accordionContent let-item let-index="index">
      <ng-container [ngSwitch]="item.id">

        <!-- Descripción -->
        <div *ngSwitchCase="'description'">
          <p class="mb-0 text-description-accordion"
          [innerHTML]="item.data.description"
          *ngIf="item.data.description; else noDesc">
          </p>
          <ng-template #noDesc>
            <p class="text-muted">No hay información disponible</p>
          </ng-template>
        </div>

        <!-- Políticas de Cancelación -->
        <div *ngSwitchCase="'policies'">
          <usb-cancellation-policies
            class="accordion-item-policies"
            #politicsSection
            [cancellationPolicies]="cancellationPolicies"
            [currencies]="currencies"
            [currencyAgency]="currencyAgency"
            [categoryId]="8">
          </usb-cancellation-policies>
        </div>

      </ng-container>
    </ng-template>

  </usb-accordion-info-product>

